import React from "react";
import { connect } from "react-redux";
import { Card } from "antd";
import SummaryHeader from "components/header/SummaryHeader";
import { LucideCalendar, UserX } from "lucide-react";
import SelectOption from "components/select/SelectOption";
import AbsenceSummaryCard from "./components/AbsenceSummaryCard";
import HeaderComponent from "components/card/HeaderComponent";
import AbsencesCard from "./components/AbsencesCard";

const TeamAbsences = () => {
  return (
    <div className="flex flex-col gap-6">
      <SummaryHeader
        title="Team Absences Overview"
        icon={UserX}
        description="Monitor team member absences and leave schedules"
        color="violet"
      />
      <AbsenceSummaryCard/>
      <Card className="rounded-xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          <SelectOption
            placeholder="All Departments"
            options={[
              { label: "All Departments", value: 0 },
              { label: "Engineering", value: 1 },
              { label: "Marketing", value: 2 },
              { label: "HR", value: 3 },
              { label: "Finance", value: 4 },
              { label: "Design", value: 5 },
              { label: "Sales", value: 6 },
            ]}
          />
          <SelectOption
            placeholder="All Locations"
            options={[
              { label: "All Locations", value: 0 },
              { label: "Philippines", value: 1 },
              { label: "India", value: 2 },
              { label: "Colombia", value: 3 },
              { label: "Sri Lanka", value: 4 }, 
            ]}
          />
          <SelectOption
            placeholder="All Status"
            options={[
              { label: "All Status", value: 0 },
              { label: "Currently On Leave", value: 1 },
              { label: "Upcoming Leave", value: 2 },
            ]}
          />
        </div>
      </Card>
      <HeaderComponent
        title="Team Member Absences"
        description="Showing 5 absences"
      >
        <div className="max-h-[500px] overflow-y-auto">
        <AbsencesCard/>

        </div>
      </HeaderComponent>
      <div class="flex items-center justify-between p-6 rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white">
        <div>
          <h4 class="font-semibold mb-1">Need to plan coverage?</h4>
          <p class="text-[13px] text-muted-foreground">
            Review upcoming absences and coordinate team coverage
          </p>
        </div>
        <button
          class="gap-2 btn-gradient-emerald h-8 px-4 py-2 text-sm"
        >
          <LucideCalendar size={16}/>
          View Calendar
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TeamAbsences);
